
import { defineComponent } from "vue";
import { changeHistory } from "./common";
export default defineComponent({
  setup() {
    return {
      changeHistory,
    };
  },
});
